export const mutateCreateAnnotation = `mutation MyMutation (
  $Content: String,
  $SlideID: String,
) {
  createAnnotation(annotation: {
    Content: $Content, 
    SlideID: $SlideID,
  }) {
    Content
    ID
    SlideID
  }
}`;

export const mutateUpdateAnnotation = `mutation MyMutation (
  $Content: String,
  $SlideID: String,
  $ID: String,
) {
  updateAnnotation(annotation: {
    Content: $Content,
    ID: $ID,
    SlideID: $SlideID,
  }) {
    Content
    ID
    SlideID
  }
}`;

export const getAnnotationGql = `query MyQuery ($id: String!) {
  getAnnotation(id: $id) {
    Content
    ID
    SlideID
  }
}`;


export const delAnnotation = `mutation MyMutation ($id: String!) {
  deleteAnnotation(id: $id) {
    Content
    ID
    SlideID
  }
}`;